import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FocusInputType, KeyValues5, KeyValues5Sets, KeyValueSet, LocalService, NumericConfig, PricingManagementWrapper } from '../../../service/local.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { GetBaseFromPriceIncludeTax, GetPriceIncludeTax } from 'src/app/supporting/conversion';

@Component({
  selector: 'app-pricing-container',
  templateUrl: './pricing-container.component.html',
  styleUrls: ['./pricing-container.component.scss']
})
export class PricingContainerComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["product_config"];

  @Input() items: PricingManagementWrapper[] = null; @Input() navigateToNextId = '';
  @Input() isNotConsiderTax: boolean = true; @Input() businessTaxes: KeyValues5Sets[]; @Input() isShowLabel = true;
  totalStaticColumns = 2; totalColumns = 0; totalRows = 0; @Input() isReadOnly = false;
  @Input() businessTax: KeyValues5[] = []; @Input() selectedBusinessTaxCategoryId: string = '';
  @Input() isExcluded = false; @Input() isSetFinalTax = true; @Input() isEnableTaxCategory = true;
  @Input() businessTaxCategories: KeyValues5[] = [];

  @Output() itemsChange = new EventEmitter<any>();
  @Output() selectedBusinessTaxCategoryIdChange = new EventEmitter<any>();

  numericConfigDefault: NumericConfig = { isDecimalAllowed: true } as NumericConfig;
  numericConfig: NumericConfig = { isDecimalAllowed: true, maxValue: 100 } as NumericConfig;

  htmlId: string = '';

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService) {
    this.htmlId = this.localService.getRandomString(5);
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);

    this.totalColumns = this.items[0].requiredTax.length + this.totalStaticColumns;
    this.totalRows = this.items.length;
    ``
  }

  ngOnChanges(): void {
    if (!this.selectedBusinessTaxCategoryId && this.businessTaxCategories && this.businessTaxCategories.length > 0) {
      this.selectedBusinessTaxCategoryId = this.businessTaxCategories.find(x => x.v3 == '1')?.key || this.businessTaxCategories[0].key;
    }

    this.onSelectBusinessTax();
  }

  ngOnDestroy(): void {
    this.selectedBusinessTaxCategoryId = '';
  }

  onSelectBusinessTax() {
    if (this.businessTaxes && this.businessTaxes.length > 0) {
      this.selectedBusinessTaxCategoryIdChange.emit(this.selectedBusinessTaxCategoryId);
      this.businessTax = this.businessTaxes.length == 1 ? this.businessTaxes[0].values : this.businessTaxes.find(x => x.key == this.selectedBusinessTaxCategoryId)?.values || [];
    }
  }

  onValidateTax(value, i, j) {
    //if (value != null && value.toString() != '' && parseFloat(value) > 100)
    //  this.items[i].requiredTax[j].v3 = "100";
  }

  arrowKeyCodes: number[] = [13, 40, 38, 37];
  onNavigate(event, currentRow, currentColumn) {
    let navigateToId = '';
    switch (event.keyCode) {
      case 13: {
        let column = this.totalColumns != currentColumn ? currentColumn + 1 : 1;
        let row = this.totalColumns != currentColumn ? currentRow : currentRow + 1;
        if (row <= this.totalRows)
          navigateToId = this.htmlId + '_txt_' + row + '_' + column;
      } break;
      case 40: {
        navigateToId = this.htmlId + '_txt_' + (currentRow + 1) + '_' + currentColumn;
      } break;
      case 38: {
        navigateToId = this.htmlId + '_txt_' + (currentRow - 1) + '_' + currentColumn;
      } break;
      case 39: {
        navigateToId = this.htmlId + '_txt_' + currentRow + '_' + (currentColumn + 1);
      } break;
      case 37: {
        navigateToId = this.htmlId + '_txt_' + currentRow + '_' + (currentColumn - 1);
      } break;
    }
    if (this.arrowKeyCodes.indexOf(event.keyCode) > -1 && navigateToId == '') {
      navigateToId = this.navigateToNextId;
    }
    if (navigateToId != '') {
      let elementToFocus = document.getElementById(navigateToId) as HTMLElement;
      if (elementToFocus) {
        elementToFocus.focus();
      } else if (event.keyCode == 40) {
        let elementToFocusNext = document.getElementById(this.navigateToNextId) as HTMLElement;
        if (elementToFocusNext) {
          elementToFocusNext.focus();
        }
      }
    }
    return navigateToId == '';
  }

  onGetFixedValue(value: string | number) {
    let data: number = 0;
    if (typeof value == 'number') {
      data = value;
    } else {
      data = parseFloat(value);
    }
    return data.toFixed(2);
  }

  onSetPriceIncludeTax(key: string, expectedBusinessType: string, focusedId: string) {
    this.taxIncludedAmount = parseFloat(this.onGetPriceIncludeTax(key, expectedBusinessType));

    this.localService.onFocusNextInput(focusedId, FocusInputType.TextBox);
  }

  onGetPriceIncludeTax(key: string, expectedBusinessType: string): string {
    this.onSetFinalTax();
    let total = 0;
    const item = this.items.find(x => x.content.key == key && x.content.v1 == expectedBusinessType);
    if (item) {
      const basePrice = item.content.v4 ? parseFloat(item.content.v4) : 0;
      total = GetPriceIncludeTax(basePrice, this.businessTax, item.requiredTax, this.isNotConsiderTax);
    }
    return total.toFixed(2);
  }

  onGetBaseFromPriceIncludeTax(key: string, expectedBusinessType: string): string {
    const item = this.items.find(x => x.content.key === key && x.content.v1 === expectedBusinessType);

    if (!item) {
      return '0.00';
    }

    const taxIncludedAmount = this.taxIncludedAmount;

    return GetBaseFromPriceIncludeTax(taxIncludedAmount, this.businessTax, item.requiredTax, this.isNotConsiderTax).toFixed(2);
  }

  taxIncludedAmount: number | null = null;
  onSetBaseFromPriceIncludeTax(key: string, expectedBusinessType: string) {
    const baseAmount = this.onGetBaseFromPriceIncludeTax(key, expectedBusinessType);
    let item = this.items.find(x => x.content.key === key && x.content.v1 === expectedBusinessType);
    if (item) {
      item.content.v4 = baseAmount;
    }
  }


  onSetFinalTax() {
    if (this.isSetFinalTax) {
      this.items.forEach(x => {
        x.taxFinal = [];
        x.requiredTax.forEach(y => {
          x.taxFinal.push({ key: y.key, value: y.v3 } as KeyValueSet);
        });
      });
    }
  }
}
